import { Injectable } from "@angular/core";
import { AppointmentRequestModel } from '../business-entities/appointmentList-model';
import { AppointmentStatusList } from "../business-entities/appointmentStatus-model";
import { ArchivedAppointmentDataService } from "../data-services/archived-appointment-data.service";
@Injectable({
  providedIn: 'root'
})

export class ArchivedAppointmentService {
  mobilenumber: string;
  licenseplatnumber: string;
  pdfTypeIndex: number;
  appointmentId: number;
  bookingDate: any = null;
  createdDate: any = null;
  AppointmentDay: any = null;
  filterTypeId: number = 0;
  dateFlag: number = 0;
  appointmentRequestModel: AppointmentRequestModel =
    {
      appointmentStatusId: null,
      workOrderStatusId: null,
      bookingDate: null,
      createdDate: null,
      dealerId: null,
      serviceAdvisorId:null,
      isAuthorizedByServiceAdvisor:false,
      mechanicId:null,
      brandCode: null,
      searchTerm: null,
      startRecordNumber: 0,
      pageSize: 0,
      sortColumn: "",
      sortDirection: "",
      appointmentType:"",
      documentPartStatus: null,
      needAttention:0,
      sourceOfCreation: '',
    };
  isShow: boolean = true;
  appointmentStatusList: AppointmentStatusList[] = [];
  isRefreshListing: boolean = true;
  constructor(private service: ArchivedAppointmentDataService,
  ) {
  }
  
  GetArchivedAppointmentList(appointmentRequestModel: AppointmentRequestModel): Promise<any> {
    return this.service.GetArchivedAppointmentList(appointmentRequestModel);
  } 
  GetAllStatusForArchivedAppointments(model: any): Promise<any> {
    return this.service.GetAllStatusForArchivedAppointments(model);
  }
  GetAllWorkOrderStatusForArchivedAppointments(model: any): Promise<any> {
    return this.service.GetAllWorkOrderStatusForArchivedAppointments(model);
  }
  DeleteArchivedAppointment(deleteModel: any): Promise<any> {
    return this.service.DeleteArchivedAppointment(deleteModel);
  }
  
  }
